/**
 * The possible diretions a segment can be aligned.
 */
export const Directions = {
  Forward: 'FORWARD', // In the direction defined by the OSM way
  Backward: 'BACKWARD', // Against the direction defined by the OSM way
  Unknown: 'UNKNOWN'
}
